import clsx from 'clsx';
import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { getImgixSrc } from '@utils/images';

interface HeroImageProps {
  heroImageWrapperClassName?: string;
  heroImageClassName?: string;
  signatureWrapperClassName?: string;
}

const HeroImage = ({
  heroImageClassName,
  heroImageWrapperClassName,
  signatureWrapperClassName,
}: HeroImageProps) => (
  <>
    <figure className={heroImageWrapperClassName}>
      <LazyImgixImage
        alt="A photo of Founder & CEO Jessica Lessin"
        className={clsx('min-h-full w-full sm:min-h-[520px] sm:max-w-[450px]', heroImageClassName)}
        src={getImgixSrc({ path: 'about/Jessica_Lessing_V2.jpg', isEnvDependent: false })}
      />
    </figure>
    <figure className={clsx('mb-0 mt-32', signatureWrapperClassName)}>
      <img
        src={getImgixSrc({
          path: 'about/signature_JL.svg',
          isEnvDependent: false,
        })}
        className="max-w-full sm:aspect-[auto] sm:max-w-[320px] sm:object-center"
        alt="A photo of Founder & CEO Jessica Lessin"
      />
      <figcaption className="mt-16">
        <span className="my-0 font-suisse-screen text-byline-lg font-bold">Jessica Lessin</span>
        <p className="my-0 font-suisse-screen text-byline-sm sm:text-byline-lg">Founder & CEO</p>
      </figcaption>
    </figure>
  </>
);

export default HeroImage;
